import React from 'react';
import "../styles/eligibility.css";

class Eligibility extends React.Component {
    render() {
        return (
            <>
                <div className="flex flex-col elig-container">                
                    <div className="containers">
                        <h1>Eligibility</h1>
                        <table class="table table-fixed">
                            <thead>
                                <tr>
                                    <th className="w-1/4">State</th>
                                    <th className="w-1/4">Current Phase</th>
                                    <th className="w-1/2">Eligibility Group</th>
                                    <th className="w-1/4">Vaccine Availability</th>
                                    <th className="w-1/4">Additional Information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Alabama</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Arizona</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>California</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Connecticut</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Delaware</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Florida</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Illinois</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Louisana</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Maryland</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Massachusetts</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>Michigan</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>New York</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>New Jersey</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                                <tr>
                                    <td>North Carolina</td>
                                    <td>Phase 1b</td>
                                    <td>Adults 75 and older and first responders, police officers and firefighters included</td>
                                    <td>Pfizer, Moderna</td>
                                    <td>Link to Website</td>
                                </tr>
                            </tbody>
                            </table>
                    </div>
                </div>
            </>
        )
    }
}

export default Eligibility;